<rask-list [data]="searchResult"
           class="footer-padding"
           [virtualScroll]="true"
           virtualScrollType="window"
           [virtualScrollItemHeight]="36"
           [fixedHeader]="true"
           [useClientFilter]="true"
           clientFilterResultText="Arbetsordrar">
    <rask-list-column width="80px">
        <ng-template let-row="row">
            <rask-icon [text]="row.externArbetsorderFelmeddelande"
                       [icon]="getIcon(row)"></rask-icon>
        </ng-template>
        <ng-template #headerTemplate>
            <rask-icon icon="far fa-info-circle" popoverClass="status-legend-popover">
                <div class="status-legend">
                    <ul class="status-legend-list">
                        <li><i [class]="externArbetsorderService.getIcon('Ok', false, false)"></i> Arbetsorder är hanterad och skickad till Viol.</li>
                        <li><i [class]="externArbetsorderService.getIcon('Ok', true, false)"></i> Arbetsorder är hanterad men behöver uppdateras mot Viol3</li>
                        <li><i [class]="externArbetsorderService.getIcon('Ok', false, true)"></i> Arbetsorder är hanterad men fått fel vid uppdatering till Viol3</li>
                        <li><i [class]="externArbetsorderService.getIcon('Fel', false, false)"></i> Arbetsorder innehåller fel som måste åtgärdas före det går att skicka till Viol3</li>
                        <li><i [class]="externArbetsorderService.getIcon('Inaktiv', false, false)"></i> Arbetsorder är inaktiv, ignorerad eller har inte hanterats</li>
                    </ul>
                </div>
            </rask-icon>
        </ng-template>
    </rask-list-column>
    <rask-list-column header="Beteckning" field="arbetsorderBeteckning" [sortable]="true" width="80px">
        <ng-template let-row="row">
            <a [routerLink]="['/planera', row.arbetsorderId]">
                {{ row.arbetsorderBeteckning }}
            </a>
            <a [routerLink]="['/planera', row.arbetsorderId]" target="_blank">
                <i class="far fa-sm fa-external-link p-r-half"></i>
            </a>
        </ng-template>
    </rask-list-column>
    <rask-list-column header="Avtalsobjekt" field="avtalsobjekt" [sortable]="true" width="60px">
        <ng-template let-row="row">
            <a [routerLink]="['/externarbetsorder', row.arbetsorderId]">
                {{ row.avtalsobjekt }}
            </a>
        </ng-template>
    </rask-list-column>
    <rask-list-column header="Namn" field="arbetsorderNamn" [sortable]="true" width="80px"></rask-list-column>
    <rask-list-column header="Uppdragsgivare" field="uppdragsgivare" [sortable]="true" width="80px">
        <ng-template let-row="row">
            <span [ngClass]="{'fst-italic' : !row.ckLeverantorKod}">{{ row.uppdragsgivare }}</span>
        </ng-template>
    </rask-list-column>
    <rask-list-column header="Produktionsområde" field="produktionsomrade" [sortable]="true"
                      width="80px"></rask-list-column>
    <rask-list-column header="Uppdaterat från Viol" field="senastUppdaterad" [sortable]="true"
                      width="80px"></rask-list-column>
    <rask-list-column header="Transport påbörjad" field="transportPaborjad" [sortable]="true"
                      width="80px"></rask-list-column>
    <rask-list-column header="Transport avslutad" field="transportAvslutad" [sortable]="true"
                      width="80px"></rask-list-column>
    <rask-list-column header="Giltig fr.o.m" field="giltigFrom" [sortable]="true" width="80px"></rask-list-column>
    <rask-list-column header="Giltig t.o.m" field="giltigTom" [sortable]="true" width="80px"></rask-list-column>
    <rask-list-column header="Anskaffningsform" field="arbetsorderAnskaffningsform" [sortable]="true"
                      width="80px"></rask-list-column>
    <rask-list-column header="Transportföretag" field="transportforetag" [sortable]="true"
                      width="80px"></rask-list-column>
</rask-list>